import React, { useContext, useEffect, useState } from "react";
import {
  BrowserRouter,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import LoginComponent from "../LoginPage/LoginComponent";
import PrivateRoutes from "./PrivateRoutes";
import CallerPage from "../Dialer/CallerPage";
import { LoginProvider } from "../LoginPage/LoginContext";
import QRFormComponent from "../QRForm/QRFormComponent";
import VistaarQRForm from "../QRForm/VistarQRForm";
import ChicksInquiryForm from "../QRForm/ChicksInquiryForm";
import GeolocationComponent from "../../GeolocationComponent";
import UnauthorizedComponent from "../UnAuthorizedPage/UnauthorizedComponent";

import PWARestrictedPageComponent from "../UnAuthorizedPage/PWARestrictedPage";
import { AuthContext } from "../LoginPage/AuthContext";
import FarmerTravelForm from "../QRForm/FarmerTravelForm";
import RegistrationManagement from "../QRForm/RegistrationManagement";
import CustomerLogin from "../CustomerLogin/CustomerLogin";
import CustomerRoot from "./CustomerRoutes";
import CustomerDashboardComponent from "../CustomerDashboard/CustomerDashboardComponent";
import CustomerPaymentDetails from "../CustomerDashboard/CustomerPaymentDetails";
import CustomerKYCDetails from "../CustomerDashboard/CustomerKYCDetails";
import AadhaarEKYCComponent from "../CustomereKYC/EKYCComponent";

const routes = createBrowserRouter([
  {
    path: "/",
    element: <LoginComponent />,
  },
  {
    path: "/customer",
    element: <CustomerRoot />,
    children: [
      { path: "login", element: <CustomerLogin /> },
      { path: "dashboard", element: <CustomerDashboardComponent /> },
      { path: "payment-details", element: <CustomerPaymentDetails /> },
      { path: "kyc-details", element: <CustomerKYCDetails /> },
      { path: "e-kyc", element: <AadhaarEKYCComponent /> },
      
    ]
  },
  {
    path: "/qrInquiry",
    element: <QRFormComponent />,
  },
  {
    path: "/qr/vistaar",
    element: <VistaarQRForm />,
  },
  {
    path: "/qr/chicks",
    element: <ChicksInquiryForm />,
  },
  {
    path: "/poultryconclave",
    element: <FarmerTravelForm />,
  },
  {
    path: "/registration/management",
    element: <RegistrationManagement />,
  },
  {
    path: "/unauthorized",
    element: <UnauthorizedComponent />,
  },
  {
    path: "/pwa-restricted",
    element: <PWARestrictedPageComponent />,
  },
  {
    path: "/*",
    element: <PrivateRoutes />,
  },
]);

function Body() {
  return (
    <>
      <LoginProvider>
        <RouterProvider router={routes} />
        {/* No additional Router here */}
      </LoginProvider>
    </>
  );
}

export default Body;
